// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d0e907c8","451":"6c0e44f9","453":"eff2808a","455":"d2cedf54","784":"fc769cc7","977":"e1f70114"}[chunkId] + ".chunk.js";
};